module.exports = __webpack_public_path__ + "img/salus_black.63e986c8.png";